import React from 'react'
import { NavLink } from 'react-router-dom'

import { Menu } from 'antd'
import { UnorderedListOutlined, AppstoreOutlined, DashboardOutlined, DollarOutlined } from '@ant-design/icons'

import { useTheme } from '../../../hooks/useTheme'
import {
  LAYOUT_VENDOR_HOME,
  LAYOUT_VENDOR_TASK_LIST,
  LAYOUT_VENDOR_FINANCE_PANEL,
  LAYOUT_VENDOR_QA_LIST
} from '../navigation'

const Sidebar = () => {
  const { data: theme, isLoading, isError } = useTheme()

  if (isLoading | isError) {
    return null
  }

  return (
    <Menu
      theme={theme?.darkMenu === 'true' ? 'dark' : 'light'}
      mode='inline'
      defaultSelectedKeys={['1-1s']}
      defaultOpenKeys={['jobs']}
      style={{ height: '100%', borderRight: 0 }}
    >
      <Menu.Item key='home' icon={<AppstoreOutlined />}>
        <NavLink to={LAYOUT_VENDOR_HOME} activeClassName='active'>
          Home
        </NavLink>
      </Menu.Item>
      <Menu.Item key='jobs' icon={<UnorderedListOutlined />}>
        <NavLink to={LAYOUT_VENDOR_TASK_LIST} activeClassName='active'>
          Jobs
        </NavLink>
      </Menu.Item>

      <Menu.Item key='finances' icon={<DollarOutlined />}>
        <NavLink to={LAYOUT_VENDOR_FINANCE_PANEL} activeClassName='active'>
          Finances
        </NavLink>
      </Menu.Item>

      <Menu.Item key='qa' icon={<DashboardOutlined />}>
        <NavLink to={LAYOUT_VENDOR_QA_LIST} activeClassName='active'>
          QA
        </NavLink>
      </Menu.Item>
    </Menu>
  )
}

export default Sidebar
